<script>
// import helper from '@/Helpers/115/115MisionHelper';
export default {
  name: 'newMissionStatus',
  props: {
    rank: {
      type: String,
      require: true,
      default: '',
    },
    isStarred: {
      type: Boolean,
      required: true,
      default: false,
    },
    missionIsStarred_Item: {
      type: Boolean,
      required: true,
      default: false,
    },
    isSelected: {
      type: Boolean,
      required: false,
      default: null,
    },
    iconClass: {
      type: String,
      required: true,
      default: '',
    },
    iconColor: {
      type: String,
      required: true,
      default: '',
    },
    otherStarred: {
      type: Boolean,
      required: true,
      default: false,
    },
    zone: {
      type: String,
      required: true,
      default: '',
    },
  },
  emits: ['removeStarredMissionBy800UserFunction'],
  methods: {},
  computed: {
    is1019State: function () {
      return this.iconClass === '10-19';
    },
  },
};
</script>
<template>
  <section>
    <v-tooltip v-if="is1019State" top>
      <template v-slot:activator="{ on, attrs }">
        <v-icon size="20px" :color="iconColor" v-bind="attrs" v-on="on">mdi-file-cancel </v-icon>
      </template>
      <span>وضعیت 19-10</span>
    </v-tooltip>
    <v-tooltip v-else-if="zone?.trim() !== '' && zone?.trim() !== '-'" top>
      <template v-slot:activator="{ on, attrs }">
        <v-icon size="20px" :color="iconColor" v-bind="attrs" v-on="on">mdi-account </v-icon>
      </template>
      <span>در حال بررسی</span>
    </v-tooltip>
    <v-tooltip v-else top>
      <template v-slot:activator="{ on, attrs }">
        <!-- @click="$emit('removeStarredMissionBy800UserFunction')" -->
        <v-icon size="17px" v-if="missionIsStarred_Item" :class="iconClass" :color="iconColor" v-bind="attrs"
          v-on="on">mdi-star
          <!-- {{ isSelected ? 'mdi-eye-outline ' : 'mdi-car-emergency ' }} -->
        </v-icon>
        <v-icon size="19px" v-else-if="false" :class="iconClass" :color="iconColor" v-bind="attrs" v-on="on">
          mdi-file-cancel
        </v-icon>
        <v-icon size="19px" v-else :class="iconClass" :color="iconColor" v-bind="attrs" v-on="on">
          mdi-car-emergency
        </v-icon>
      </template>
      <span>وضعیت {{ missionIsStarred_Item ? 'ستاره دار ' : '' }} {{ rank }}</span>
    </v-tooltip>
  </section>
</template>
<style lang="scss"></style>
